// extracted by mini-css-extract-plugin
var _1 = "RentalPortalIntegrationsRow-moduleRentalPortalIntegrationsRow__iyojB TableComponent-modulerow__xPAo4";
export { _1 as "RentalPortalIntegrationsRow" }
